module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice-note-list row column"
  }, [_c('base-list', {
    ref: "baseList",
    attrs: {
      "component": _vm.component,
      "dataLoader": _vm.loadZones
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1a45febd!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/NoteList.vue
// module id = 2287
// module chunks = 1